import { VFC } from 'react'
import styled from 'styled-components'
import { HOW_TO, PROHIBITION } from '../../assets/images'
import { Link } from '../../elements/Link'
import { FREE_COMPANY_ALERT_URL, SERVICE_EXPLAIN_URL } from '../../utils/routes'

export const TopPageBanner: VFC<{ free: boolean }> = ({ free }) => (
  <BannerWrapper>
    <BannerDiv>
      <div>
        <Link href={FREE_COMPANY_ALERT_URL}>
          <img src={PROHIBITION} alt="" />
        </Link>
      </div>
      {free && (
        <div>
          <Link href={SERVICE_EXPLAIN_URL}>
            <img src={HOW_TO} alt="" />
          </Link>
        </div>
      )}
    </BannerDiv>
  </BannerWrapper>
)

export const BANNER_HEIGHT = '205px'
export const BANNER_MARGIN = '32px'
const BannerWrapper = styled.div`
  position: relative;
`
const BannerDiv = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  position: absolute;
  align-items: center;

  @media screen and (max-width: 1024px) {
    display: block;
    text-align: center;
  }

  img {
    max-height: ${BANNER_HEIGHT};
    margin: ${BANNER_MARGIN} 28px;

    @media screen and (max-width: 1024px) {
      max-width: 100%;
      margin: calc(${BANNER_MARGIN} * 0.5) auto;
    }

    :hover {
      opacity: 0.6;
    }
  }
`
